import { useSiteContext } from "@/lib/utils/tracking/siteContext"

interface eyeFitUInjectionProps {
    productId?: string
    productName?: string
}

export default function EyeFitUInjectionPoint({
    productId,
    productName
}: eyeFitUInjectionProps) {
    const siteContext = useSiteContext()

    const handleSizeGuideClick = () => {
        if (productId && productName) {
            import("@/lib/utils/tracking/gtmEvents").then(({ pdpSizeGuideEvent }) => {
                pdpSizeGuideEvent(productId, productName, siteContext)
            })
        }
    }

    return <div id="eyefitu-injection-point" onClick={handleSizeGuideClick} />
}
